import { TableSchema } from '../metadata-schema';
import { dim_per_periode } from './dim_per_periode';
import { dim_br_brin } from './dim_br_brin';
import { dim_ilt_opleidingscode } from './dim_ilt_opleidingscode';
import { instelling } from './instelling';
import { fac_lb_loopbaan } from './fac_lb_loopbaan';
import { dim_lg_lesgroep } from './dim_lg_lesgroep';
import { dim_ll_leerling } from './dim_ll_leerling';
import { dim_mw_medewerker } from './dim_mw_medewerker';
import { dim_vk_vak } from './dim_vk_vak';
import { dim_vs_vestiging } from './dim_vs_vestiging';

export const fac_lr_lesregistratie: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "fac_lr_lesregistratie",
	"description": "Definitie voor fact tabel fac_lr_lesregistratie uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.FacTable",
		"nl.topicus.cumlaude.metadata.table.Leerlingspecifiek",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek",
		"nl.topicus.cumlaude.metadata.table.Vakspecifiek"
	],
	"properties": {
		"lr_d_datum": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Definitie voor dimension tabel dim_per_periode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_per_periode
		},
		"lr_des_lesregistratie": {
			"type": "string",
			"label": "Omschrijving",
			"category": "Lesregistratie",
			"example": "Te laat, ...",
			"description-magister": "Het absentietype dat in Magister is vastgelegd bij deze lesregistratie (verantwoording in Magister).\nDit is gedetailleerder dan het veld Lesregistratie, dat het verantwoordingstype bevat. Bij de absentietypes kunnen in Magister bijvoorbeeld meerdere varianten van \"Te laat\" worden ingericht."
		},
		"lr_fk_br_vest": {
			"description": "Definitie voor dimension tabel dim_br_brin uit de CumLaude DWH",
			"type": "object",
			"schema": dim_br_brin
		},
		"lr_fk_ilt": {
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"lr_fk_ilt_volgend_sj": {
			"labelSuffix": "volgend schooljaar",
			"include": [
				"ilt_nm_niveau"
			],
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"lr_fk_ilt_vorig_sj": {
			"labelSuffix": "vorig schooljaar",
			"include": [
				"ilt_nm_niveau"
			],
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"lr_fk_inst": {
			"description": "Definitie voor sys tabel instelling uit de CumLaude sys",
			"type": "object",
			"schema": instelling
		},
		"lr_fk_lb": {
			"exclude": [
				"lb_co_brin_svh",
				"lb_co_brin_vestiging",
				"lb_nm_klas",
				"lb_nm_lichting",
				"lb_nm_onderwijssoort",
				"lb_nm_vestiging"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"lr_fk_lb_volgend_sj": {
			"labelSuffix": "volgend schooljaar",
			"include": [
				"lb_abb_leerfase",
				"lb_co_brin",
				"lb_co_brin_vestiging",
				"lb_nm_klas",
				"lb_nm_leerfase",
				"lb_nm_opleiding",
				"lb_nm_vestiging",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"lr_fk_lb_vorig_sj": {
			"labelSuffix": "vorig schooljaar",
			"include": [
				"lb_abb_leerfase",
				"lb_co_brin",
				"lb_co_brin_vestiging",
				"lb_nm_klas",
				"lb_nm_leerfase",
				"lb_nm_opleiding",
				"lb_nm_vestiging",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"lr_fk_lg": {
			"exclude": [
				"lg_nm_docenten"
			],
			"description": "Definitie voor dimension tabel dim_lg_lesgroep uit de CumLaude DWH",
			"type": "object",
			"schema": dim_lg_lesgroep
		},
		"lr_fk_ll": {
			"exclude": [
				"ll_is_cohortstatus_tot_volledig",
				"ll_nm_basisschooladvies",
				"ll_nm_basisschooladvies_uni",
				"ll_nm_basisschooladvies_uni_herzien",
				"ll_nm_onderwijssoort_svb",
				"ll_nm_schoolsoort_svb",
				"ll_nm_schoolsoort_svh",
				"ll_nm_svb",
				"ll_nm_svh",
				"ll_nr_citototaalscore"
			],
			"description": "Definitie voor dimension tabel dim_ll_leerling uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ll_leerling
		},
		"lr_fk_mw_ingevoerd_door": {
			"labelOverride": {
				"mw_abb_medewerker": "Ingevoerd door (afkorting)",
				"mw_nm_medewerker": "Ingevoerd door"
			},
			"categoryOverride": {
				"mw_abb_medewerker": "Lesregistratie",
				"mw_nm_medewerker": "Lesregistratie"
			},
			"descriptionOverride": {
				"mw_abb_medewerker": "De afkorting van de medewerker die deze lesregistratie heeft ingevoerd.",
				"mw_nm_medewerker": "De achternaam, voornaam/-letters, eventueel voorvoegsel en afkorting van de medewerker die deze lesregistratie heeft ingevoerd."
			},
			"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
			"type": "object",
			"schema": dim_mw_medewerker
		},
		"lr_fk_mw_mentor1": {
			"labelOverride": {
				"mw_abb_medewerker": "Eerste mentor (afkorting)",
				"mw_nm_medewerker": "Eerste mentor"
			},
			"categoryOverride": {
				"mw_abb_medewerker": "Opleiding",
				"mw_nm_medewerker": "Opleiding"
			},
			"descriptionOverride": {
				"mw_abb_medewerker": "De afkorting van de eerste mentor.",
				"mw_nm_medewerker": "De achternaam, voornaam/-letters, eventueel voorvoegsel en afkorting van de eerste mentor."
			},
			"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
			"type": "object",
			"schema": dim_mw_medewerker
		},
		"lr_fk_mw_mentor2": {
			"labelOverride": {
				"mw_abb_medewerker": "Tweede mentor (afkorting)",
				"mw_nm_medewerker": "Tweede mentor"
			},
			"categoryOverride": {
				"mw_abb_medewerker": "Opleiding",
				"mw_nm_medewerker": "Opleiding"
			},
			"descriptionOverride": {
				"mw_abb_medewerker": "De afkorting van de tweede mentor.",
				"mw_nm_medewerker": "De achternaam, voornaam/-letters, eventueel voorvoegsel en afkorting van de tweede mentor."
			},
			"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
			"type": "object",
			"schema": dim_mw_medewerker
		},
		"lr_fk_mw_mentor_indiv": {
			"labelOverride": {
				"mw_abb_medewerker": "Individuele mentor (afkorting)",
				"mw_nm_medewerker": "Individuele mentor"
			},
			"categoryOverride": {
				"mw_abb_medewerker": "Opleiding",
				"mw_nm_medewerker": "Opleiding"
			},
			"descriptionOverride": {
				"mw_abb_medewerker": "De afkorting van de individuele mentor.",
				"mw_nm_medewerker": "De achternaam, voornaam/-letters, eventueel voorvoegsel en afkorting van de individuele mentor."
			},
			"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
			"type": "object",
			"schema": dim_mw_medewerker
		},
		"lr_fk_vk": {
			"description": "Definitie voor dimension tabel dim_vk_vak uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vk_vak
		},
		"lr_fk_vs": {
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"lr_fk_vs_bekostiging": {
			"include": [],
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"lr_fks_mw": {
			"type": "array",
			"items": {
				"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
				"type": "object",
				"schema": dim_mw_medewerker
			}
		},
		"lr_fun_is_plaatsing_peildatum_1april": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-aprilplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 april van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 april wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"lr_fun_is_plaatsing_peildatum_1aug": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-augustusplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 augustus van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 augustus wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"lr_fun_is_plaatsing_peildatum_1dec": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-decemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 december van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 december wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"lr_fun_is_plaatsing_peildatum_1feb": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-februariplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 februari van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 februari wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"lr_fun_is_plaatsing_peildatum_1jan": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-januariplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 januari van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 januari wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"lr_fun_is_plaatsing_peildatum_1juli": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-juliplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 juli van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 juli wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"lr_fun_is_plaatsing_peildatum_1juni": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-juniplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 juni van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 juni wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"lr_fun_is_plaatsing_peildatum_1mei": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-meiplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 mei van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 mei wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"lr_fun_is_plaatsing_peildatum_1mrt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-maartplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 maart van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 maart wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"lr_fun_is_plaatsing_peildatum_1nov": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-novemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 november van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 november wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"lr_fun_is_plaatsing_peildatum_1okt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-oktoberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 oktober van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 oktober wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"lr_fun_is_plaatsing_peildatum_1sep": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-septemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 september van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 september wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"lr_fun_nm_instroommoment": {
			"type": "string",
			"label": "Instroommoment",
			"filter": false,
			"category": "Doorstroom",
			"example": "T/m 1 oktober, Na 1 oktober, Na 1 november, ...",
			"description": "Het moment binnen het schooljaar waarin de leerling is ingestroomd vanuit een andere school of vestiging.\nIndien de leerling is ingestroomd op of voor 1 oktober van dit schooljaar, is deze waarde 'T/m 1 oktober', anders 'Na' de voorgaande eerste van de maand (oktober t/m juli).\nLeeg als deze leerling dit schooljaar niet is ingestroomd vanuit een andere school of vestiging."
		},
		"lr_fun_nm_nationaliteit": {
			"type": "string",
			"label": "Nationaliteit",
			"category": "Leerling",
			"grouping": false,
			"exportable": false,
			"example": "Nederlandse, Turkse, ..."
		},
		"lr_fun_nm_vak_uni": {
			"type": "string",
			"label": "Vak (uniform)",
			"category": "Vak",
			"example": "Engels, wiskunde, ..."
		},
		"lr_fun_nr_maanden_instroom_na_1okt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 10,
			"label": "Instroommoment",
			"grouping": false,
			"exportable": false,
			"category": "Doorstroom",
			"example": "0 - 10",
			"description": "Het aantal maanden (afgerond naar boven) tussen 1 oktober van dit schooljaar en het moment van instroom, mits deze leerling dit schooljaar is ingestroomd vanuit een andere school of vestiging.\nIndien de leerling is ingestroomd op of voor 1 oktober van dit schooljaar, is deze waarde 0.\nLeeg als deze leerling dit schooljaar niet is ingestroomd vanuit een andere school of vestiging."
		},
		"lr_fun_nr_plaatsing_advies_score": {
			"type": "number",
			"label": "Pl./adviesverschil (score)",
			"category": "Plaatsing",
			"example": "-1; 0; 0,5; 1"
		},
		"lr_fun_nr_plaatsing_advies_verschil": {
			"type": "number",
			"label": "Pl./adviesverschil (niveaus)",
			"category": "Plaatsing",
			"example": "0; -1,5; 2; -0,5; ..."
		},
		"lr_fun_nr_plaatsing_lj3_advies_score": {
			"type": "number",
			"label": "Pl./adviesverschil lj3 (score)",
			"category": "Plaatsing",
			"example": "-1; 0; 0,5; 1"
		},
		"lr_fun_nr_plaatsing_lj3_advies_verschil": {
			"type": "number",
			"label": "Pl./adviesverschil lj3 (niveaus)",
			"category": "Plaatsing",
			"example": "0; -1,5; 2; -0,5; ..."
		},
		"lr_is_geoorloofd": {
			"type": "number",
			"minimum": 0,
			"maximum": 1,
			"label": "Geoorloofd",
			"category": "Lesregistratie",
			"example": "Geoorloofd, Ongeoorloofd"
		},
		"lr_nm_afspraaktype": {
			"type": "string",
			"label": "Afspraaktype",
			"category": "Lesregistratie",
			"example": "Les, Kwt, Persoonlijk, ...",
			"description-somtoday": "Het type van de afspraak waarvoor deze lesregistratie geldt.",
			"description-magister": "Het type van de afspraak waarvoor deze lesregistratie geldt.\nDe mogelijke waarden zijn: Onbekend, Persoonlijk, Algemeen, Schoolbreed, Stage, Kwt, Les of Planning."
		},
		"lr_nm_klas": {
			"type": "string",
			"label": "Klas",
			"category": "Opleiding",
			"example": "1V2, 2B3, 3H4, ..."
		},
		"lr_nm_lesregistratie": {
			"type": "string",
			"label": "Lesregistratie",
			"category": "Lesregistratie",
			"example": "Te laat, ..."
		},
		"lr_nm_opleiding": {
			"type": "string",
			"label": "Opleiding",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lr_nm_vak": {
			"type": "string",
			"label": "Vak",
			"category": "Vak",
			"example": "Engels, wiskunde, ..."
		},
		"lr_nr_leerjaar": {
			"type": "number",
			"label": "Leerjaar",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lr_nr_leerling": {
			"type": "number",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"bestuur": true
			}
		},
		"lr_nr_lesuur": {
			"type": "number",
			"label": "Lesuur",
			"category": "Lesregistratie",
			"example": "1-8"
		},
		"lr_ts_begin": {
			"type": "string",
			"format": "date-time",
			"label": "Begindatum/tijd",
			"category": "Lesregistratie",
			"filter": false,
			"grouping": false,
			"example": "21-04-2023 8:20"
		},
		"lr_ts_eind": {
			"type": "string",
			"format": "date-time",
			"label": "Einddatum/tijd",
			"category": "Lesregistratie",
			"filter": false,
			"grouping": false,
			"example": "21-04-2023 9:05"
		}
	}
};
